import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./navbar.css";

import { Download } from "../../assets/icons/download2";
import NavMenu from "../Menu/navMenu";
import SearchItems from "../Modals/SearchItems";
import Searchbar from "../Searchbar";
import DotMenuItems from "./DotMenuItems";
import NavButtons from "./navButtons";
import NavItems from "./NavItems";

import useWindowDimensions from "../../hooks/useWindowDimensions";
import { toggleCategoryDropdown } from "../../redux/slices/activityCategories";
import { toggleModal as toggleDuonutModal, updateSettings } from "../../redux/slices/duonutSettings";
import { openModal, showSignInForm, showSignUpForm } from "../../redux/slices/formDetails";
import { updateIsLoggedIn } from "../../redux/slices/user";

import { setUserActivity, updateDiscardSaveModal, updateIsEditing } from "../../redux/slices/userActivity";
import { editActivities, publishActivities } from "../../services/activity";
import { isUserActivityUpdated } from "../../utils";
import SuccessModal from "../Modals/SuccessModal/SuccessModal";
import PublishButton from "../PublishButton/publishButton";

export default function Navbar() {
  const navigate = useNavigate();

  const [scrollPosition, setScrollPosition] = useState(0);
  const [searchItemsActive, setSearchItemsActive] = useState(false);
  const [dotMenuItemsActive, setDotMenuItemsActive] = useState(false);
  const { categoryDropdownActive } = useSelector((state) => state.activityCategories);
  const { categories, duonutToEdit, coverPhoto } = useSelector((state) => state.duonutSettings);

  const dispatch = useDispatch();
  const location = useLocation();

  const [navMenuActive, setNavMenuActive] = useState(false);
  const { width } = useWindowDimensions();

  const handleClick = () => dispatch(openModal());

  const handleScroll = () => setScrollPosition(window.pageYOffset);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const { userActivities, selectedUserActivity, isEditing } = useSelector((state) => state.userActivity);
  const { title, description, isPublic, isPrivate, category } = useSelector((state) => state.duonutSettings.settings);
  const { isLoggedIn } = useSelector((state) => state.user);
  const [successModalActive, setSuccessModalActive] = useState(false);

  const [error, setError] = useState(false);

  //close category dropdown when location changes
  useEffect(() => {
    if (categoryDropdownActive) dispatch(toggleCategoryDropdown({ active: categoryDropdownActive ? false : true }));
  }, [location]);

  const resetUserActivities = () => {
    // dispatch(updateSettings({ settings }))
    // dispatch(updateIsEditing({ isEditing: false }))
    localStorage.removeItem("userActivities");
    localStorage.removeItem("duonutSettings");
    // dispatch(setUserActivity({ activities: [{}], defaultActivities: [{}] }))
  };

  const handleNavigate = (navigateTo) => {
    if (navigateTo === "/") {
      if (!isLoggedIn && isUserActivityUpdated(userActivities)) return dispatch(updateDiscardSaveModal(true));
      if (isLoggedIn) {
        navigate("/");
      } else {
        window.location = "/";
      }
      window.scrollTo(0, 0);
    } else if (navigateTo === "/pdf") {
      if (isLoggedIn) return navigate("/pdf");
      dispatch(updateDiscardSaveModal(true));
    }
  };

  useEffect(() => {
    if (isLoggedIn) {
      // setSuccessModalActive(true);
      setTimeout(() => {
        setSuccessModalActive(false);
      }, 2000);
    }
  }, [isLoggedIn]);

  useEffect(() => {
    if (location.pathname.substring(0, 7) === "/design") return;
    if (location.pathname === "/pdf") return;
    else {
      let settings = {
        title: "",
        description: "",
        isPublic: true,
        isPrivate: false,
        category: 1,
      };
      dispatch(setUserActivity({ activities: [{}], defaultActivities: [{}] }));
      resetUserActivities();
      dispatch(updateSettings({ settings }));
      dispatch(updateIsEditing({ isEditing: false }));
    }
  }, [location.pathname]);

  return (
    <>
      <div
        className={scrollPosition < 1 ? "navbar-container" : "navbar-container navbar-container-collapse"}
        id={location.pathname === "/" ? "" : "navbar-short"}
        style={{ boxShadow: location.pathname !== "/" || location.pathname.substring(0, 7) !== "/design" ? "0px 2px 10px rgba(61, 59, 59, 0.1)" : "" }}
      >
        <div className="navbar__wrapper" id={location.pathname.substring(0, 7) === "/design" ? "navbar-short" : ""}>
          <div
            className="d-flex align-items-center navbar__wrapper__left navbar__wrapper__top"
            style={{ justifyContent: location.pathname.substring(0, 7) === "/design" && width <= 1275 ? "left" : "center" }}
          >
            {/* hamburger menu for mobile- hidden on pc */}

            <div className="navbar_wrapper__hamberger_menu icon-button" onClick={() => setNavMenuActive(true)} id={location.pathname.substring(0, 7) === "/" ? "" : "hidden"}>
              <img src="/assets/icons/hamburger-menu.svg" alt="" />
            </div>

            {location.pathname === "/" || location.pathname.substring(0, 7) === "/design" ? (
              <></>
            ) : (
              <div className="icon-button mobile-only back-button" onClick={() => navigate(-1)} style={{ display: "flex" }}>
                <img src="./assets/icons/angle-left.svg" alt="" />
              </div>
            )}

            <div onClick={() => handleNavigate("/")} className="navbar__user_icon home_icon icon-button">
              <img src="/assets/icons/home.svg" alt="" />
            </div>

            {/* logo  */}

            <div onClick={() => handleNavigate("/")} className="navbar__logo">
              <img src={width >= 1100 ? "/assets/logo.png" : "./assets/logo-white.png"} className={`${width <= 1275 ? "logo-small" : ""}`} id={width <= 1100 ? "hidden" : ""} alt="" />
            </div>

            <div className="input-box" onClick={() => setSearchItemsActive(true)} id={location.pathname === "/" || location.pathname.substring(0, 7) === "/design" ? "" : "hidden"}>
              {/* <input /> */}
              <Searchbar iconColor="black" placeholder="Search any activity" />
            </div>

            {location.pathname === "/" || location.pathname.substring(0, 7) === "/design" ? (
              <></>
            ) : (
              <div className="nav-header mobile-only">
                {location.pathname === "/allduonuts" && "All Duonuts"}
                {location.pathname === "/myduonuts" && "My Duonuts"}
              </div>
            )}
            <NavItems />

            {/* for mobile */}
            {
              width < 1100 &&
            <PublishButton className="btn-secondary  navbar__user_icon mobile-navbar" setError={setError} /> 
            }
            {/* <div className="navbar__user_icon icon-button" style={{ marginLeft: "auto", marginRight: "30px" }} onClick={() => handleNavigate("/pdf")}>
              <Download fill="#fff" />
            </div> */}

            <div className="navbar__user_icon icon-button dot-menu" onClick={() => setDotMenuItemsActive(!dotMenuItemsActive)}>
              <img src="/assets/icons/dotMenu.svg" alt="" />
            </div>
          </div>

          <NavButtons width={width} setSuccessModalActive={setSuccessModalActive} handleNavigate={handleNavigate} handleClick={handleClick} />

          {/* for android homepage - hidden on other page */}
          {scrollPosition < 1 && (
            <div className="navbar-bottom" id={location.pathname === "/" ? "active" : ""}>
              <p>Let's Create</p>
            </div>
          )}
        </div>
        <NavMenu setNavMenuActive={setNavMenuActive} navMenuActive={navMenuActive} />
        {searchItemsActive && <SearchItems setSearchItemsActive={setSearchItemsActive} searchItemsActive={searchItemsActive} />}
        {dotMenuItemsActive && <DotMenuItems setDotMenuItemsActive={setDotMenuItemsActive} handleNavigate={handleNavigate} />}
      </div>
      {successModalActive && (
        <SuccessModal
          hideHeader={true}
          hideButtons={true}
          message={
            <>
              <img src="/assets/icons/tick.svg" alt="" />
              <p style={{ marginTop: "24px" }}>Login Successful</p>
            </>
          }
        />
      )}
    </>
  );
}
